import React from 'react';
import PropTypes from 'prop-types';
import { ContentLayout } from './styles';
import TabSelector from './TabSelector';
import MenuDropdown from '../DropDown/MenuDropdown';

const Tabs = ({ device, tabsOptions, sectionName, currentTab, setCurrentTab, setQueryTab = () => {} }) => {
  return (
    <>
      {device === 'desktop' && (
        <ContentLayout>
          {tabsOptions.map(tab => {
            return (
              <TabSelector
                key={tab}
                tab={tab}
                sectionName={sectionName}
                isSelected={currentTab === tab}
                setSelectTab={setCurrentTab}
                setQueryTab={setQueryTab}
              />
            );
          })}
        </ContentLayout>
      )}
      {device !== 'desktop' && (
        <MenuDropdown
          optionSelected={currentTab}
          tabsOptions={tabsOptions}
          setCurrentTab={setCurrentTab}
          setQueryTab={setQueryTab}
          sectionName='contactosPermisos'
        />
      )}
    </>
  );
};

Tabs.propTypes = {
  device: PropTypes.string.isRequired,
  tabsOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  sectionName: PropTypes.string.isRequired,
  currentTab: PropTypes.string.isRequired,
  setCurrentTab: PropTypes.func.isRequired
};

export default Tabs;
